import { movies } from "@/mocks/catalog";

const heroPosters = [movies[6], movies[0], movies[8]];
const stats = [
  { value: "6 大", label: "主类型分区" },
  { value: "1000+", label: "片库条目" },
  { value: "每日", label: "更新榜单" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100 pt-24 md:pt-28">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 h-64 w-64 rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 md:px-6 lg:grid-cols-2 lg:gap-14 lg:pb-24">
        <div className="animate-fade-up flex flex-col gap-6">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-sparkling-2-line"></i>
            一站式影视类型导览
          </span>
          <h1 className="font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-[2.75rem]">
            星辰影院：把六大类型
            <span className="text-primary-600">一次看明白</span>
          </h1>
          <p className="max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里按<strong className="font-medium text-foreground-900">动作片、爱情片、科幻片、恐怖片、喜剧片与电视剧</strong>
            六大类型整理影片线索，从评分、题材到看点都一目了然。你可以先看分类速览确定方向，再用类型筛选缩小范围，最后在榜单里对比热度，挑出今晚想看的那一部。
          </p>

          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#explorer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-eye-line"></i>
              进入类型筛选
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-layout-grid-line"></i>
              查看六个分类
            </a>
          </div>

          <dl className="mt-2 flex flex-wrap gap-6 border-t border-background-300/70 pt-6">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col">
                <dt className="font-heading text-xl font-semibold text-foreground-950">{s.value}</dt>
                <dd className="text-xs text-foreground-500">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up relative">
          <div className="grid grid-cols-3 gap-3 md:gap-4">
            <div className="col-span-2 row-span-2 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="aspect-[3/4] w-full">
                <img
                  src={heroPosters[0].poster}
                  alt={`${heroPosters[0].title} 海报`}
                  title={`${heroPosters[0].title} 科幻片海报`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
            {heroPosters.slice(1).map((m) => (
              <div key={m.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="aspect-[2/3] w-full">
                  <img
                    src={m.poster}
                    alt={`${m.title} 海报`}
                    title={`${m.title} ${m.genre}海报`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="animate-float absolute -bottom-4 left-4 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:left-8">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <div className="leading-tight">
              <p className="text-xs text-foreground-500">今日热度第一</p>
              <p className="font-heading text-sm font-semibold text-foreground-950">星轨之外 · 9.2</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}